export default __webpack_public_path__ + "static/media/logo-hori.b0e96d87.png";